// extracted by mini-css-extract-plugin
module.exports = {"Topic":"Topic-2JrCsjia"};